export const slate = {
  1: { value: { base: '{colors.slate.light.1}', _dark: '{colors.slate.dark.1}' } },
  2: { value: { base: '{colors.slate.light.2}', _dark: '{colors.slate.dark.2}' } },
  3: { value: { base: '{colors.slate.light.3}', _dark: '{colors.slate.dark.3}' } },
  4: { value: { base: '{colors.slate.light.4}', _dark: '{colors.slate.dark.4}' } },
  5: { value: { base: '{colors.slate.light.5}', _dark: '{colors.slate.dark.5}' } },
  6: { value: { base: '{colors.slate.light.6}', _dark: '{colors.slate.dark.6}' } },
  7: { value: { base: '{colors.slate.light.7}', _dark: '{colors.slate.dark.7}' } },
  8: { value: { base: '{colors.slate.light.8}', _dark: '{colors.slate.dark.8}' } },
  9: { value: { base: '{colors.slate.light.9}', _dark: '{colors.slate.dark.9}' } },
  10: { value: { base: '{colors.slate.light.10}', _dark: '{colors.slate.dark.10}' } },
  11: { value: { base: '{colors.slate.light.11}', _dark: '{colors.slate.dark.11}' } },
  12: { value: { base: '{colors.slate.light.12}', _dark: '{colors.slate.dark.12}' } },
  a1: { value: { base: '{colors.slate.light.a1}', _dark: '{colors.slate.dark.a1}' } },
  a2: { value: { base: '{colors.slate.light.a2}', _dark: '{colors.slate.dark.a2}' } },
  a3: { value: { base: '{colors.slate.light.a3}', _dark: '{colors.slate.dark.a3}' } },
  a4: { value: { base: '{colors.slate.light.a4}', _dark: '{colors.slate.dark.a4}' } },
  a5: { value: { base: '{colors.slate.light.a5}', _dark: '{colors.slate.dark.a5}' } },
  a6: { value: { base: '{colors.slate.light.a6}', _dark: '{colors.slate.dark.a6}' } },
  a7: { value: { base: '{colors.slate.light.a7}', _dark: '{colors.slate.dark.a7}' } },
  a8: { value: { base: '{colors.slate.light.a8}', _dark: '{colors.slate.dark.a8}' } },
  a9: { value: { base: '{colors.slate.light.a9}', _dark: '{colors.slate.dark.a9}' } },
  a10: { value: { base: '{colors.slate.light.a10}', _dark: '{colors.slate.dark.a10}' } },
  a11: { value: { base: '{colors.slate.light.a11}', _dark: '{colors.slate.dark.a11}' } },
  a12: { value: { base: '{colors.slate.light.a12}', _dark: '{colors.slate.dark.a12}' } },
}
